<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-user-alt"></i> Point of Contact</h4>
  </div>
  <div class="content-details">
    <form action="" [formGroup]="knowledgeForm">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Name <span class="text-danger">*</span></mat-label>
              <input
                matInput
                placeholder="Enter Name"
                readonly="{{ showForm }}"
                formControlName="hostinstheadname"
              />
              <mat-error
                *ngIf="
                  setting.hostinstheadname.touched &&
                  setting.hostinstheadname.errors
                "
              >
                <span *ngIf="setting.hostinstheadname.errors.required"
                  >Name is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Designation <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Designation "
                formControlName="hostinstheaddesignation"
                readonly="{{ showForm }}"
              />
              <mat-error
                *ngIf="
                  setting.hostinstheaddesignation.touched &&
                  setting.hostinstheaddesignation.errors
                "
              >
                <span *ngIf="setting.hostinstheaddesignation.errors.required">
                  Designation is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Mobile Number <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Mobile Number "
                type="text"
                readonly="{{ showForm }}"
                formControlName="hostinstheadmobile"
                oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                maxlength="10"
                minlength="10"
              />
              <mat-error
                *ngIf="
                  knowledgeForm.get('hostinstheadmobile').hasError('required')
                "
              >
                Mobile Number is required
              </mat-error>
              <mat-error
                *ngIf="
                  knowledgeForm.get('hostinstheadmobile').hasError('pattern')
                "
              >
                <i class="fas fa-exclamation-triangle"></i>
                Invalid Mobile
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >E-mail Id <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                formControlName="hostinstheademail"
                placeholder="Enter E-mail Id"
                readonly="{{ showForm }}"
                oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                type="text"
                (keydown.space)="$event.preventDefault()"
              />

              <mat-error
                *ngIf="
                  knowledgeForm.get('hostinstheademail').hasError('required')
                "
              >
                Email Id is required
              </mat-error>
              <mat-error
                *ngIf="knowledgeForm.get('hostinstheademail').hasError('email')"
              >
                <i class="fas fa-exclamation-triangle"></i>
                Invalid Email
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <div class="text-center mt-4" *ngIf="!showForm">
      <button mat-raised-button color="primary" (click)="saveBtn()">
        Save
      </button>
    </div>
  </div>
</section>
